import Loader, { LoaderType } from '../../../components/loader'
import { useClubMachineState, useClubQuery } from '../hooks'
import { isCareerClub } from '../utils'
import ClubRegistration from './ClubRegistration'
import { Page } from '../../../components/Page'
import ClubDetailPage from './ClubDetailPage'
import { ClubMachineProvider } from 'state'
import { useMachineLogger } from 'state/machines/helpers'

const ClubHandlerContent = () => {
  const { club, clubQuery, inviteId } = useClubQuery()
  const { machine } = useClubMachineState()

  useMachineLogger(machine)

  if (!club || clubQuery.isFetching) {
    return <Loader type={LoaderType.fullscreen} />
  }

  let content = <ClubDetailPage />

  if (isCareerClub(club) && !inviteId) {
    content = <ClubRegistration />
  }

  return (
    <Page
      head={{
        title: club?.title,
        description: club?.feature_text,
        image: club?.hero_image || club?.current_book?.cover_image_small,
        seoTitle: club?.seo_title,
        seoDescription: club?.seo_description,
        canonical: true,
        url: club?.url,
      }}
    >
      {content}
    </Page>
  )
}

const ClubHandler = () => (
  <ClubMachineProvider>
    <ClubHandlerContent />
  </ClubMachineProvider>
)

export default ClubHandler
